/**
 * Подписи чекпоинтов — рантайм-значения к типу из proposal-contract.d.ts.
 *
 * Лежит в shared как .ts (а не .d.ts), потому что это значения, а не типы.
 * Импортируется только фронтом; бэкенду подписи не нужны, поэтому в его
 * сборку файл не попадает и структуру dist не меняет.
 */

import type { CheckpointType } from './proposal-contract.js';

export const CHECKPOINT_LABELS: Record<CheckpointType, string> = {
  sale_closed: 'Сделка закрыта',
  appointment_booked: 'Запись на встречу',
  contact_captured: 'Контакт получен',
  issue_resolved: 'Проблема решена',
};

/** Порядок в меню — от самого ценного */
export const CHECKPOINT_ORDER: readonly CheckpointType[] = [
  'sale_closed',
  'appointment_booked',
  'contact_captured',
  'issue_resolved',
];
